export const mJump = url => {
  let ua = navigator.userAgent.toLowerCase()
  if (ua.match(/iPad/i) == 'ipad' || ua.match(/iphone/i) == 'iphone' || ua.match(/android/i) == 'android') {
    window.location.href = url
  }
}
